module.exports = __webpack_public_path__ + "static/IndIAA-Awards-2018-f79bdb39fa57088a720e5d604ab4d369.png";